import {InsuranceReceiverType,InsuranceTypesType } from "../../Insurance/types";

export type ParamsType = {
  fromDate: string;
  toDate: string;
};

export type InsuranceClaimSummaryReportType = {
  insuranceId: number;
  totApprovedClaims: number;
  totclaims: number;
  totclaimed: number;
  totRej: number;
  insuranceName: string;
  totApproved: number;
  totRejClaims: number;
};

export type InsuranceWiseClaimReportType = {
  patName: string;
  insuranceName: string;
  insShare: number;
  patShare: number;
  rejAcptReason: null | string | number;
  visitNo: number;
  claim: null | string | number;
  claimStatus: string;
  createdByDate: string;
};

export type InsuranceClaimDetailsReportType = {
  patientName: string;
  insuranceName: string;
  submissionType: string;
  submissionStatus: string;
  insShare: number;
  receivedAmt: string;
  createdByDate: string;
};

export type ClaimSearchFormType = {
  fromDate: string;
  toDate: string;
  insuranceType: InsuranceTypesType | null;
  receiver: InsuranceReceiverType | null;
  payer: InsuranceReceiverType | null;
};

export const initialData:ClaimSearchFormType = {
  fromDate: "",
  toDate: "",
  insuranceType: null,
  receiver: null,
  payer: null,
}